import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link as LinkIcon, Check } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Toolbar button on the public share page that copies a stable public JSON
 * data link to the clipboard. External tools (ChatGPT, scripts) can GET the
 * link to receive full project data without executing JavaScript.
 *
 * Backed by `/api/public/furniture/{share_token}` on the server.
 */
export function ExportProjectButton({ shareToken }) {
  const [copied, setCopied] = useState(false);
  if (!shareToken) return null;
  const dataUrl = `${window.location.origin}/api/public/furniture/${shareToken}`;

  const handle = async () => {
    try {
      await navigator.clipboard.writeText(dataUrl);
    } catch {
      // Fallback for older browsers / insecure contexts
      const ta = document.createElement('textarea');
      ta.value = dataUrl;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success('Project data link copied — paste it to ChatGPT');
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handle}
      className="gap-1.5"
      data-testid="toolbar-export-project-btn"
    >
      {copied
        ? <><Check className="h-4 w-4 text-emerald-600" /> Copied!</>
        : <><LinkIcon className="h-4 w-4" /> Copy Project Data Link</>}
    </Button>
  );
}
